import { useQuery } from '@tanstack/react-query';
import { connectorsApi, type ConnectorListOptions } from '../api/connectors';

// Metadata only. Explicit actor/account/site prevent reusing another context's list.
export const connectorKeys = {
  all: ['connectors'] as const,
  list: (actorId: string, options: ConnectorListOptions) => ['connectors', actorId, options] as const,
};
export function useConnectors(actorId: string, options: ConnectorListOptions = {}) {
  return useQuery({ queryKey: connectorKeys.list(actorId, options), queryFn: () => connectorsApi.list(options), enabled: !!actorId });
}
